/* eslint-disable max-lines */
import { css } from 'linaria';
import { overSearchOverlay } from '../../../../styles/z-indexs';

export const searchBar = css`
  height: 40px;
`;

export const searchbarForm = css``;

export const searchbarInputWrap = css`
  position: fixed;
  /* to disable scroll on focus in safari */
  top: 145px;
  left: -9999px;
  z-index: -1;
  display: flex;
  align-items: center;
  will-change: left, top, width, transform;

  @media (--from-desktop) {
    top: 20px;
  }
`;

export const searchbarInput = css`
  width: 100%;
  padding: 11px 40px 11px 12px;
  font-weight: 400;
  font-size: 14px;
  font-family: inherit;
  line-height: 18px;
  color: var(--text-secondary);
  background: var(--control-minor);
  border: none;
  border-radius: 4px;
  box-shadow: none;
  transition: background 0.3s ease-out, transform 0.3s cubic-bezier(0.24, 0.81, 0.2, 0.96),
    box-shadow 0.3s cubic-bezier(0.24, 0.81, 0.2, 0.96);
  -webkit-appearance: none;
  appearance: none;
  -webkit-tap-highlight-color: transparent;

  &::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }

  &::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }

  &::-webkit-input-placeholder {
    font-weight: 400;
    font-size: 14px;
    font-family: inherit;
    line-height: 18px;
    color: var(--text-secondary);
  }

  &::-moz-placeholder {
    font-weight: 400;
    font-size: 14px;
    font-family: inherit;
    line-height: 18px;
    color: var(--text-secondary);
  }

  &::-webkit-search-decoration,
  &::-webkit-search-cancel-button,
  &::-webkit-search-results-button,
  &::-webkit-search-results-decoration {
    display: none;
  }

  &:-ms-input-placeholder {
    font-weight: 400;
    font-size: 14px;
    font-family: inherit;
    line-height: 18px;
    color: var(--text-secondary);
  }

  &:focus {
    outline: none;
  }

  &.expanded {
    color: var(--control-primary);
    background: var(--background-primary);
    box-shadow: 0 4px 20px rgba(72, 78, 92, 0.15);
  }
`;

export const pseudoInput = css`
  --button-color: var(--text-secondary) !important;
  --button-bg: var(--control-minor) !important;
  --button-hover-bg: var(--control_hover-minor) !important;
  justify-content: start !important;

  height: 40px;
  padding: 0 40px 0 12px !important;
  font-weight: 400 !important;
  line-height: 18px;
  border: none;

  &[hidden] {
    display: none;
  }
`;

export const pseudoInputContent = css`
  overflow: hidden;
`;

export const searchClear = css`
  position: absolute !important;
  right: 10px !important;
  display: none !important;

  &.show {
    display: block !important;
  }
`;

export const loader = css`
  position: absolute !important;
  left: 0;
  right: 0;
  bottom: 0;
  animation-name: DelayedContent;
  animation-duration: 0s;
  animation-delay: 300ms;
  animation-fill-mode: both;

  @keyframes DelayedContent {
    from {
      visibility: hidden;
    }
    to {
      visibility: visible;
    }
  }
`;

export const suggestionsContainer = css`
  position: fixed;
  z-index: ${overSearchOverlay};
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  height: 100%;
  padding-top: 28px;
  padding-left: 8px;
  margin-left: -8px;
  overflow-x: hidden;
  overflow-y: auto;
  opacity: 0;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
`;

/*
  Fix for buttons, as they have different sizing rules in according to
  https://www.w3.org/TR/CSS22/visudet.html#block-replaced-width
 */
export const suggestionButton = css`
  width: calc(100% + 8px);
  text-align: start;
`;

export const suggestion = css`
  display: block !important;
  padding: 8px !important;
  margin: 0 0 0 -8px !important;
  border-radius: 4px !important;

  &.active {
    --button-bg: var(--background-secondary);
  }
`;

export const suggestionsTitle = css`
  flex: 0 0 90px;
  padding: 9px 1px;
  font-size: 14px;
  line-height: 18px;
  color: var(--text-minor);

  @media (--only-mobile) {
    flex: auto;
  }
`;

export const suggestionsWrapper = css`
  display: flex;

  @media (--only-mobile) {
    flex-direction: column;
  }
`;

export const suggestionsList = css`
  width: 100%;
`;

export const errorContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 72px;
  color: var(--text-secondary);
`;

export const errorTitle = css`
  margin-bottom: 16px;
  text-align: center;
`;

export const nothingFound = css`
  color: var(--color-text);
`;
